import { createSlice } from '@reduxjs/toolkit';
import omit from 'lodash/omit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: null,
  board: {
    cards: {},
    columns: {},
    columnOrder: [],
  },
  open:{
    cardId:null,
    message:[]
  }
};

const slice = createSlice({
  name: 'kanban',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET BOARD
    getBoardSuccess(state, action) {
      state.isLoading = false;
      const board = action.payload;
      console.log("dentro board", board)
      const cards = action.payload;
      console.log("dentro cards", cards)
      const columns = objFromArray([{"id":"0","name":"Por hacer","cardIds":[]},{"id":"1","name":"En proceso","cardIds":[]},{"id":"2","name":"Validación","cardIds":[]}, {"id":"3","name":"Terminadas","cardIds":[]}]);
      console.log("dentro columns", columns)

      const columnOrder = ["0","1","2","3"];
      state.board = {
        cards,
        columns,
        columnOrder,
      };
    },

    // CREATE NEW COLUMN
    createColumnSuccess(state, action) {
      const newColumn = action.payload;
      state.isLoading = false;
      state.board.columns = {
        ...state.board.columns,
        [newColumn.id]: newColumn,
      };
      state.board.columnOrder.push(newColumn.id);
    },

    persistCard(state, action) {
      const columns = action.payload;
      state.board.columns = columns;
    },

    persistColumn(state, action) {
      state.board.columnOrder = action.payload;
    },

    addTask(state, action) {
      const { card, columnId } = action.payload;
      console.log("malan", action)

      state.board.cards[0].push(card)
      state.board.columns[columnId].cardIds.push(card.id);
    },

    addMessage(state, action){
      const {message, taskId} = action.payload;
      console.log("mensajep", action.payload)
      state.open.message=message
      state.open.cardId=taskId

    },

    addNewMessage(state, action){
      const message = [... state.open.message];
      message.push(action.payload)
      console.log("mensajep", action.payload)
      state.open.message=message

    },

    moveTask(state, action){
      const card = action.payload;
      console.log("paqui", action.payload)
      console.log("paqui2", state)

      state.board.cards[card.stage].push( action.payload)
      state.board.cards[card.stage -1] = state.board.cards[card.stage -1].filter((task) => task._id !== card._id);
    },

    moveBackTask(state, action){
      const card = action.payload;
      console.log("paqui", action.payload)
      console.log("paqui2", state)

      state.board.cards[card.stage].push( action.payload)
      state.board.cards[card.stage +1] = state.board.cards[card.stage +1].filter((task) => task._id !== card._id);
    },

    deleteTask(state, action) {
      const { cardId, columnId } = action.payload;

      state.board.columns[columnId].cardIds = state.board.columns[columnId].cardIds.filter((id) => id !== cardId);
      state.board.cards = omit(state.board.cards, [cardId]);
    },

    // UPDATE COLUMN
    updateColumnSuccess(state, action) {
      const column = action.payload;

      state.isLoading = false;
      state.board.columns[column.id] = column;
    },

    // DELETE COLUMN
    deleteColumnSuccess(state, action) {
      const { columnId } = action.payload;
      const deletedColumn = state.board.columns[columnId];

      state.isLoading = false;
      state.board.columns = omit(state.board.columns, [columnId]);
      state.board.cards = omit(state.board.cards, [...deletedColumn.cardIds]);
      state.board.columnOrder = state.board.columnOrder.filter((c) => c !== columnId);
    },
  },
});

// Reducer
export default slice.reducer;

export const { actions } = slice;

// ----------------------------------------------------------------------

export function getBoard(cargo) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      console.log("ver cargo", cargo)
      // {"board":{"cards":[],"columns":[],"columnOrder":[]}}
      // {"column":{"id":"5037fefc-815a-4dcc-b0a8-798149a4c3f6","name":"asd","cardIds":[]}}
      // const response = {"board":{"cards":[{"id":"deb02f04-9cf8-4f1e-97e0-2fbda84cc6b3","name":"Call with sales of HubSpot","description":"Duis condimentum lacus finibus felis pellentesque, ac auctor nibh fermentum. Duis sed dui ante. Phasellus id eros tincidunt, dictum lorem vitae, pellentesque sem. Aenean eu enim sit amet mauris rhoncus mollis. Sed enim turpis, porta a felis et, luctus faucibus nisi. Phasellus et metus fermentum, ultrices arcu aliquam, facilisis justo. Cras nunc nunc, elementum sed euismod ut, maximus eget nibh. Phasellus condimentum lorem neque. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Fusce sagittis pharetra eleifend. Suspendisse potenti.","assignee":[{"id":"473d2720-341c-49bf-94ed-556999cf6ef7","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg","name":"Lucian Obrien"}],"due":[1676804934925,1676891334925],"attachments":[],"comments":[{"id":"338ff85d-3685-4d5e-9e5a-f31af0d2f2f8","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_1.jpg","name":"Jayvion Simon","createdAt":"2023-02-13T11:08:54.925Z","messageType":"text","message":"Assumenda nam repudiandae rerum fugiat vel maxime."},{"id":"17621d01-cff0-4b77-b6f8-d2fd61349d46","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg","name":"Lucian Obrien","createdAt":"2023-02-12T10:08:54.925Z","messageType":"text","message":"Quis veniam aut saepe aliquid nulla."},{"id":"28bb4df8-1468-4ec8-92b1-0e8cdeea3d2d","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg","name":"Deja Brady","createdAt":"2023-02-11T09:08:54.925Z","messageType":"text","message":"Reprehenderit ut voluptas sapiente ratione nostrum est."},{"id":"22685910-2e5b-480f-8c7a-a897529adb66","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg","name":"Harrison Stein","createdAt":"2023-02-10T08:08:54.925Z","messageType":"image","message":"https://api-prod-minimal-v4.vercel.app/assets/images/covers/cover_7.jpg"},{"id":"8d7f19b8-c246-4d2c-b27c-db676b2a4347","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg","name":"Reece Chung","createdAt":"2023-02-09T07:08:54.925Z","messageType":"text","message":"Quo quia sit nihil nemo doloremque et."},{"id":"dbcb7be9-dcd7-48bd-b631-5fcb374636d3","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg","name":"Lainey Davidson","createdAt":"2023-02-08T06:08:54.925Z","messageType":"image","message":"https://api-prod-minimal-v4.vercel.app/assets/images/covers/cover_9.jpg"},{"id":"36076a2c-b389-4bb6-a979-f1acaf041a7f","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_7.jpg","name":"Cristopher Cardenas","createdAt":"2023-02-07T05:08:54.925Z","messageType":"text","message":"Tempora officiis consequuntur architecto nostrum autem nam adipisci."},{"id":"49b56bc0-5705-41ec-8edf-3975a1155d5e","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_8.jpg","name":"Melanie Noble","createdAt":"2023-02-06T04:08:54.925Z","messageType":"text","message":"Voluptas sunt magni adipisci praesentium saepe."}],"completed":true},{"id":"98bf6e8b-becc-485b-9c3f-a7d09392c48d","name":"Interview for the Asis. Sales Manager","description":"We are looking for vue experience and of course node js strong knowledge","assignee":[{"id":"473d2720-341c-49bf-94ed-556999cf6ef7","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg","name":"Deja Brady"},{"id":"b8395203-887c-46f5-a85f-339b2d75c98b","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg","name":"Harrison Stein"},{"id":"18e23ac9-c874-43e4-8163-2d37f15f3367","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_4.jpg","name":"Reece Chung"},{"id":"a3be5485-03bf-47a6-b553-a9cf9f070ed8","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_5.jpg","name":"Lainey Davidson"},{"id":"048f6343-7a65-4873-a570-eb6ff4eb1ba3","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg","name":"Cristopher Cardenas"}],"due":[1676804934925,1676891334925],"attachments":["https://api-prod-minimal-v4.vercel.app/assets/images/covers/cover_2.jpg"],"comments":[],"completed":false},{"id":"99fbc02c-de89-4be3-9515-f8bd12227d38","name":"Change the height of the top bar because it looks too chunky","description":"We nede to make it aggressive with pricing because it’s in their interest to acquire us","assignee":[],"due":[null,null],"attachments":[],"comments":[],"completed":true},{"id":"ab9cebca-6cb4-4847-aa17-3b261b3dd0fb","name":"Integrate Stripe API","description":"We nede to make it aggresive with pricing because it’s in their interest to acquire us","assignee":[{"id":"b8395203-887c-46f5-a85f-339b2d75c98b","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_3.jpg","name":"Melanie Noble"},{"id":"a3be5485-03bf-47a6-b553-a9cf9f070ed8","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_6.jpg","name":"Chase Day"}],"due":[null,null],"attachments":["https://api-prod-minimal-v4.vercel.app/assets/images/covers/cover_4.jpg"],"comments":[],"completed":false},{"id":"ebf0d26a-78e5-414f-986f-003d8fcd3154","name":"Update the customer API for payments","description":"We need to make it aggresive with pricing because it’s in their interest to acquire us","assignee":[{"id":"473d2720-341c-49bf-94ed-556999cf6ef7","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg","name":"Shawn Manning"}],"due":[null,null],"attachments":[],"comments":[],"completed":true},{"id":"9d98ce30-3c51-4de3-8537-7a4b663ee3af","name":"Release minimals DS","description":"Production","assignee":[{"id":"473d2720-341c-49bf-94ed-556999cf6ef7","avatar":"https://api-prod-minimal-v4.vercel.app/assets/images/avatars/avatar_2.jpg","name":"Soren Durham"}],"due":[null,null],"attachments":[],"comments":[],"completed":true}],"columns":[{"id":"8cd887ec-b3bc-11eb-8529-0242ac130003","name":"Backlog","cardIds":["deb02f04-9cf8-4f1e-97e0-2fbda84cc6b3","98bf6e8b-becc-485b-9c3f-a7d09392c48d","99fbc02c-de89-4be3-9515-f8bd12227d38"]},{"id":"23008a1f-ad94-4771-b85c-3566755afab7","name":"Progress","cardIds":["ab9cebca-6cb4-4847-aa17-3b261b3dd0fb","ebf0d26a-78e5-414f-986f-003d8fcd3154"]},{"id":"37a9a747-f732-4587-a866-88d51c037641","name":"Q&A","cardIds":[]},{"id":"4ac3cd37-b3e1-466a-8e3b-d7d88f6f5d4f","name":"Production","cardIds":["9d98ce30-3c51-4de3-8537-7a4b663ee3af"]}],"columnOrder":["8cd887ec-b3bc-11eb-8529-0242ac130003","23008a1f-ad94-4771-b85c-3566755afab7","37a9a747-f732-4587-a866-88d51c037641","4ac3cd37-b3e1-466a-8e3b-d7d88f6f5d4f"]}}
      // {"board":{"cards":[],"columns":[{"id":"5037fefc-815a-4dcc-b0a8-798149a4c3f6","name":"asd","cardIds":[]}],"columnOrder":["5037fefc-815a-4dcc-b0a8-798149a4c3f6"]}}
      // const response2= {"board":{"cards":[],"columns":[{"id":"5037fefc-815a-4dcc-b0a8-798149a4c3f6","name":"Por hacer","cardIds":[]},{"id":"65113345-b547-4021-89ae-4e7068ced8b9","name":"En proceso","cardIds":[]},{"id":"65113345-b547-4021-8w9ae-4e7068ced8b9","name":"confirmacion","cardIds":[]}, {"id":"65113345-b5wq47-4021-89ae-4e7068ced8b9","name":"terminadas","cardIds":[]}],"columnOrder":["1","2","3","4"]}}
      const response3=[[{"titulo":"cambiar clave", "description":"uis condimentum lacus finibus", "stage":0,"id":14, "priority":3, "deadline":"13-12-2023"}, {"titulo":"cambiar12321 clave", "stage":2, "description":"uis condimentum lacus finibus", "id":15, "priority":1, "deadline":"13-12-2023"}], [ {"titulo":"cambiar12321 En proceso", "stage":2, "description":"uis condimentum lacus finibus", "id":15, "priority":1, "deadline":"13-12-2023"}]]
      const response = await axios.get('/api/task/', {params:{cargo}});
      console.log("response3", response3.data)
      console.log("response", response)
      dispatch(slice.actions.getBoardSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function createColumn(newColumn) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/api/kanban/columns/new', newColumn);
      dispatch(slice.actions.createColumnSuccess(response.data.column));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateColumn(columnId, updateColumn) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/api/kanban/columns/update', {
        columnId,
        updateColumn,
      });
      dispatch(slice.actions.updateColumnSuccess(response.data.column));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function moveTask(cardId, move) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.put('/api/task/update/move', {cardId, move});
      if (move===0){
        dispatch(slice.actions.moveTask(response.data));
      }else{
        dispatch(slice.actions.moveBackTask(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------


export function deleteColumn(columnId) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post('/api/kanban/columns/delete', { columnId });
      dispatch(slice.actions.deleteColumnSuccess({ columnId }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function persistColumn(newColumnOrder) {
  return () => {
    dispatch(slice.actions.persistColumn(newColumnOrder));
  };
}

// ----------------------------------------------------------------------

export function persistCard(columns) {
  return () => {
    dispatch(slice.actions.persistCard(columns));
  };
}

// ----------------------------------------------------------------------

export function addTask({ card, columnId }) {
  return async() => {
    // dispatch(slice.actions.startLoading());
    // const delay = ms => new Promise(res => setTimeout(res, ms));
    try {
      const _id= await axios.post('/api/task/', card)
      card._id= _id.data
      card.viewedBy=[]
      // await delay(5000);
      console.log("cardo", card)
      dispatch(slice.actions.addTask({ card, columnId }));

    } catch (error) {
      console.log("asdsa", error)
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
export function getMessage(taskId) {
  return async() => {
    try {
      console.log("mañan no hay clases", taskId)
      const response = await axios.get('/api/taskMsj/', {params:{taskId}});
      console.log(response)
      dispatch(slice.actions.addMessage({message: response.data, taskId}))
      // const comresp= [... comments]
      // comresp.push(response.data)
      // setComments(comresp)
      // await delay(5000);
      // console.log("cardo", card)
      // dispatch(slice.actions.addTask({ card, columnId }));

    } catch (error) {
      console.log("asdsa", error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ------------------------------------------------------------------------
export function addMessage(comment) {
  return () => {
    try {
      console.log("mañana no hay clases", comment)
      
      dispatch(slice.actions.addNewMessage(comment))

    } catch (error) {
      console.log("asdsa", error)
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteTask({ cardId, columnId }) {
  return (dispatch) => {
    dispatch(slice.actions.deleteTask({ cardId, columnId }));
  };
}

export function viewed(cardId) {
  return async () => {
    // dispatch(slice.actions.startLoading());
    try {
      await axios.post('/api/task/add/view', { cardId });
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
